module.exports = __webpack_public_path__ + "img/android.6bbef985.jpg";